/**
 * 视口相机命令通道（P0-3d B-1）：页面层把自由视角相机"摆到"指定位姿。
 *
 * 与 viewProbe（读实时相机）对偶：viewProbe 是"视口→数据"，这里是"数据→视口"。
 * 结构同 runtimeRegistry：命令式旁路，不进 React 状态。ViewCommander 在 Canvas 内注册
 * 真正的实现（能拿到 camera + OrbitControls），页面层调用 viewCommand.apply(pose)。
 */
export interface ViewPoseRequest {
  position: readonly [number, number, number];
  target: readonly [number, number, number];
}

export const viewCommand: { apply: (pose: ViewPoseRequest) => void } = {
  apply: () => {
    /* 未挂载视口时为空操作 */
  },
};
